import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import moment from 'moment';
import { EventsProvider } from '../../providers/events/events';
import { NavController, NavParams, PopoverController, Platform, ModalController, Events, LoadingController } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { LocationsProvider } from '../../providers/locations/locations';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';
import { FilteringProvider } from '../../providers/filtering/filtering';
import { CoEventDetailsComponent } from '../co-event-details/co-event-details';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller'
import { SoundsProvider } from '../../providers/sounds/sounds';
/**
 * Generated class for the CoEventsDayComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-events-day',
  templateUrl: 'co-events-day.html',
  inputs: ['popOverFilter', 'currentDate']

})
export class CoEventsDayComponent {
  eventsQueryArgs: string;
  todayEvents: any;
  calendarLine: Array<string> = [];
  @Input('currentDate') currentDate;
  @Input('currentFilters') currentFilters;
  @Output() onDatePicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() currentDensityForFilters: EventEmitter<any> = new EventEmitter<any>();
  @Output() eventQueryTimeArgs: EventEmitter<any> = new EventEmitter<any>();
  @Output() keywordSearchEmit: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('eventView') eventView;
  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;
  eventsCheck: boolean = true;
  searchTags: any;
  checkLast: number = 0;
  @Input('popOverFilter') popOverFilter: any;
  filteredTodayEvents: any = [];
  currentDensity: number;
  density3Array: any;
  density3Object: any;
  pageLoaded: boolean = false;
  clientKeyword: any;
  viewType: string;
  screenWidth: any;
  aboveWidthBreakpoint: boolean;
  showKeywordBox: boolean = false;
  searchForKeyword: string = "";
  // @ViewChild('scroll') virtualScroller;
  constructor(public eventsProvider: EventsProvider, public filteringProvider: FilteringProvider, public config: ConfigProvider, public navCtrl: NavController, public locationsProvider: LocationsProvider, public navParams: NavParams, private clientDetails: ClientDetailsProvider, public state: AppState, public platform: Platform, public modalCtrl: ModalController, public popoverCtrl: PopoverController, private events: Events, private loadingCtrl: LoadingController, private sounds : SoundsProvider) {
    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = state.mode;
      self.screenWidth = self.platform.width();
      self.platform.width() > 992 ? self.aboveWidthBreakpoint = true : self.aboveWidthBreakpoint = false;
    });
  }

  ngOnInit() {
    // console.log('please show me', )
    if (this.currentFilters && this.currentFilters.date){
      this.eventsQueryArgs = `startDate: "${this.currentFilters.date.lower.format("YYYY-MM-DD 00:00:00")}", endDate: "${this.currentFilters.date.upper.format("YYYY-MM-DD HH:mm:ss")}"`;
      this.eventQueryTimeArgs.emit({start: this.currentFilters.date.lower.format("YYYY-MM-DD 00:00:00"), end: this.currentFilters.date.upper.format("YYYY-MM-DD HH:mm:ss")})
      // console.log('weeo', this.eventsQueryArgs, this.currentFilters);
    } else {
      this.eventsQueryArgs = `startDate: "${moment(this.currentDate).subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(this.currentDate).format("YYYY-MM-DD HH:mm:ss")}"`;
      this.eventQueryTimeArgs.emit({start: moment(this.currentDate).subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss"), end: moment(this.currentDate).format("YYYY-MM-DD HH:mm:ss")})
      // this.eventsQueryArgs = `startDate: "${moment(this.currentDate).startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(this.currentDate).endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
    }
    if (this.currentFilters.keyword && this.currentFilters.keyword.length > 0){
      this.showKeywordBox = true;
      this.searchForKeyword = this.currentFilters.keyword;
    }
    this.queryEvents(this.eventsQueryArgs);
    this.calendarLoad(this.currentDate);
    const appRootIos = document.querySelector('.app-root-ios');
    if (appRootIos) {
      for(let x=0; x<10; x++){
        setTimeout(() => {
          appRootIos['style']['zIndex'] = appRootIos['style']['zIndex'] === '1' ? '2' : '1';
        }, x * 400);
      }
    }
  }
  ngOnDestroy(){
    this.events.unsubscribe('updateAllEvents');
  }
  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }
  goToEventDetails(eventId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoEventDetailsComponent, { eventId: eventId });
    });
  }

  updateBrochureStartDay(date){
    this.eventQueryTimeArgs.emit({start: moment(date).startOf('day').format("YYYY-MM-DD HH:mm:ss"), end: moment(date).endOf('day').format("YYYY-MM-DD HH:mm:ss")})
  }

  //duplicate of above, need to pass date as currentdate is not inputed from parent in time
  resetDayView(date) {
    this.eventsQueryArgs = `startDate: "${moment(date).subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(date).format("YYYY-MM-DD HH:mm:ss")}"`;
    this.queryEvents(this.eventsQueryArgs);
    this.calendarLoad(date);
  }

  dayClicked(date: string) {
    this.eventsQueryArgs = `startDate: "${moment(date).subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(date).format("YYYY-MM-DD HH:mm:ss")}"`;
    this.queryEvents(this.eventsQueryArgs);
    this.calendarLoad(date);
    this.onDatePicked.emit(date);
  }

  queryEvents(args, currentFilters?) {
    let loader = this.loadingCtrl.create({
      content:"Retrieving events..."
    });
    loader.present();
    this.eventsProvider.getEvents(args).then((res) => {
      this.updateBrochureStartDay(this.currentDate);
      let allEvents = res.allEvents;
      this.events.subscribe('updateAllEvents', async () => {
        this.todayEvents = await this.eventsProvider.checkInterestedEvents(res);
      });
      this.todayEvents = allEvents;
      this.filteredTodayEvents = allEvents;
      this.searchTags = res.searchTypes;
      this.pageLoaded = true;
      allEvents.length > 0 ? this.eventsCheck = true : this.eventsCheck = false;

      if (currentFilters){
        this.filterByPopOver(currentFilters);
      } else {
        this.filterByPopOver(this.popOverFilter);
      }

      this.createDensityThreeArray();

      loader.dismiss().catch(err=>{});
    });
  }
  createDensityThreeArray(){
    this.density3Object = this.filteredTodayEvents.reduce((red, event) => {
      let currentEventTime = moment(event.eventStart).format("YYYY-DDD HH");
      if (!red[currentEventTime]) red[currentEventTime] = [];
      red[currentEventTime].push(event);
      return red;
    }, {});
    this.density3Array = Object.keys(this.density3Object).map((key) => {
      return this.density3Object[key];
    });
  }
  isDateRangeApplied(){
    return (this.popOverFilter && this.popOverFilter.date && !this.popOverFilter.date.lower.isSame(this.popOverFilter.date.upper, 'day'))
  }
  calendarLoad(date: string) {
    let selectedDate = moment(date).subtract(3, 'day');
    this.calendarLine = [];
    for (let x = 0; x < 7; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'day').format("YYYY-MM-DD HH:mm:ss"))
    }
  };

  nextWeek(date: string) {
    let selectedDate = moment(date).add(1, 'week');
    this.calendarLine = [];
    for (let x = 0; x < 7; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'day').format("YYYY-MM-DD HH:mm:ss"));
    }
    selectedDate = moment(selectedDate).add(3, 'day');
    this.eventsQueryArgs = `startDate: "${moment(selectedDate).subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(selectedDate).format("YYYY-MM-DD HH:mm:ss")}"`;
    this.queryEvents(this.eventsQueryArgs)
    this.onDatePicked.emit(selectedDate);
  }

  filterByPopOver(filterObj){
    this.filteringProvider.filterByPopover(filterObj, this.todayEvents).then((res)=>{
      this.filteredTodayEvents = res;
      if (this.currentDensity === 3){
        this.createDensityThreeArray();
      }
    })
  }

  updateKeywordFilter(){
    // console.log(this.searchForKeyword)
    if (this.searchForKeyword.length > 0) this.keywordSearchEmit.emit({keyword: this.searchForKeyword.toLowerCase()});
  }

  cancelKeywordFilter(){
    this.keywordSearchEmit.emit({keyword: ''})
  }

  previousWeek(date: string) {
    let selectedDate = moment(date).subtract(1, 'week');
    this.calendarLine = [];
    for (let x = 0; x < 7; x++) {
      this.calendarLine.push(moment(selectedDate).add(x, 'day').format("YYYY-MM-DD HH:mm:ss"));
    }
    selectedDate = moment(selectedDate).add(3, 'day');
    this.eventsQueryArgs = `startDate: "${moment(selectedDate).subtract(1, 'day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(selectedDate).format("YYYY-MM-DD HH:mm:ss")}"`;
    this.queryEvents(this.eventsQueryArgs);
    this.onDatePicked.emit(selectedDate);
  }

  generateCalendarForward() {
    let endDate;
    endDate = this.calendarLine[this.calendarLine.length - 1];
    for (let x = 1; x < 21; x++) {
      this.calendarLine.push(moment(endDate).add(x, 'day').format("YYYY-MM-DD HH:mm:ss"));
    };
  }

  generateCalendarBackward() {
    let endDate;
    this.calendarLine.reverse();
    endDate = this.calendarLine[this.calendarLine.length - 1];
    for (let x = 1; x < 21; x++) {
      this.calendarLine.push(moment(endDate).subtract(x, 'day').format("YYYY-MM-DD HH:mm:ss"));
    };
    this.calendarLine.reverse();
  }

  updateDensity(density: number) {
    let className = "density" + density.toString();
    // let allEventViews = document.getElementsByClassName('eventView');
    let allEventViews = this.eventView.nativeElement;
    allEventViews.className = (className + " eventView");
    this.currentDensity = density;
    this.currentDensityForFilters.emit(density);
    if (this.pageLoaded && this.virtualScroller){
      this.virtualScroller.scrollToPosition(0, 100);
    }
  }

  getEventColor(eventType, barOrText) {
    if (barOrText == 'text') {
      try {
        let eventTypeObject = this.searchTags.find(object => object.name === eventType);
        return eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    } else {
      try {
        let eventTypeObject = this.searchTags.find(object => object.name === eventType);
        return "2px solid " + eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    }
  }

  screenWidthAboveBP() {
    if (this.platform.width() > 992) {
      return true;
    } else {
      return false;
    };
  };

}


// WEBPACK FOOTER //
// ./src/components/co-events-day/co-events-day.ts